var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: 19,
    viewBox: "0 0 90 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "#494949",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logos-/-tink-/-wordmark-(black-+-lax)",
    transform: "translate(220.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tink_wordmark_Lax",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3952897,37.5091335 C9.45767769,37.5091335 8.45459066,36.0758782 8.45459066,33.9976581 L8.45459066,24.729274 L14.9030073,24.729274 L14.9030073,20.4772834 L8.45459066,20.4772834 L8.45459066,13.0482436 L3.46303855,13.0482436 L3.46303855,20.4772834 L0,20.4772834 L0,24.7770492 L3.15255923,24.7770492 L3.15255923,34.117096 C3.15255923,38.8468384 6.23346939,41.9761124 11.6071499,41.9761124 C13.1356635,41.9761124 14.4731128,41.7133489 15.2134866,41.4028103 L15.0463054,37.0313817 C14.2103996,37.3896956 13.3506107,37.5091335 12.3952897,37.5091335 Z",
    id: "Path",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#494949",
    x: 18.2943967,
    y: 20.4772834,
    width: 5.27814841,
    height: 21.3077283
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8815638,20.2622951 C35.6812386,20.2622951 33.4601173,21.6 32.2182,23.5587822 L32.0510188,20.4772834 L26.9878177,20.4772834 L26.9878177,41.7611241 L32.242083,41.7611241 L32.242083,29.6740047 C32.242083,26.759719 34.1049589,24.8009368 36.9709219,24.8009368 C39.6697037,24.8009368 41.0549191,26.5925059 41.0549191,29.5784543 L41.0549191,41.7611241 L46.3808335,41.7611241 L46.3808335,28.3840749 C46.3808335,23.4632319 43.6104027,20.2622951 38.8815638,20.2622951 Z",
    id: "Path",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#494949",
    points: "61.3077238 29.2918033 69.236888 20.4772834 62.9078865 20.4772834 54.8831902 29.6740047 54.8831902 13.0482436 49.6050418 13.0482436 49.6050418 41.7611241 54.8831902 41.7611241 54.8831902 36.3864169 57.9163343 33.0421546 64.0303886 41.7611241 70.0489108 41.7611241"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#494949",
    x: 18.6114943,
    y: 12.8571429,
    width: 5.07586207,
    height: 5.14285714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0027954,7.03122924 C75.6269609,7.03122924 78.5641931,3.98272425 78.5641931,0.221262458 L83.7990989,0.221262458 C83.7990989,6.9820598 78.5168184,12.4644518 72.0027954,12.4644518 L72.0027954,7.03122924 Z",
    id: "Path",
    fill: "#F89572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5788138,12.4890365 C85.9546483,12.4890365 83.0174161,15.5375415 83.0174161,19.2990033 C83.0174161,23.0604651 85.9546483,26.1089701 89.5788138,26.1089701 L89.5788138,31.5421927 C83.0647908,31.5421927 77.7825103,26.0598007 77.7825103,19.2990033 C77.7825103,12.538206 83.0647908,7.05581395 89.5788138,7.05581395 L89.5788138,12.4890365 Z",
    id: "Path",
    fill: "#F89572"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTink);
export default __webpack_public_path__ + "static/media/tink.49a681fc2785ae3c739fac7ddcc10d62.svg";
export { ForwardRef as ReactComponent };